import STORE from '../../store';

const addTimelineEvent = (newEvent: Timeline.Event, accountId: string) => {
  return STORE.getTimelineEventsRef({ accountId })
    .doc(newEvent.id)
    .set(newEvent);
};

export default addTimelineEvent;
